import React from 'react';
import { string, object } from 'prop-types';
import { Button } from '@fiverr-private/fit';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { createSourceInfo } from '../../../../../shared/utils/bi';
import '../../../../../shared/components/Video/ExplanationVideo/index.scss';
import BannerVideo from '../../../../../shared/components/Video/BannerVideo';
import { WEBSITE_MATCH_LINK, VIDEO_CONFIG } from './constants';
import { reportWebsiteMatch, reportVideoWatch, getBannerImpressionEnrichment } from './utils';
import './index.scss';

const WebsiteMatchBanner = ({ context }) => {
    const { pageCtxId, userId } = getContext();
    const impressionEnrichment = getBannerImpressionEnrichment(userId, pageCtxId);
    const bqContext = { ...context, pageCtxId, userId };
    const [ref] = useImpressionItem({ enrichment: impressionEnrichment });

    const sourceInfo = createSourceInfo({
        videoName: VIDEO_CONFIG.name,
        mixpanelPageName: {},
        bigQueryPageName: {}
    });

    return (
        <div className="match-banner-wrapper" ref={ref}>
            <WebsiteMatchTitle/>
            <div className="step-wrapper">
                <WebsiteMatchStep subtitle={<I18n k="match.banner.steps.first"/>} number="1"/>
                <WebsiteMatchStep subtitle={<I18n k="match.banner.steps.second"/>} number="2"/>
                <WebsiteMatchStep subtitle={<I18n k="match.banner.steps.third"/>} number="3"/>
            </div>
            <div className="btn-group">
                <Button className="redirect-btn"
                    size={Button.SIZES.LARGE}
                    onClick={() => reportWebsiteMatch(bqContext)}
                    href={WEBSITE_MATCH_LINK} target="_blank">
                    <I18n k="match.banner.website_cta"/>
                </Button>
                <BannerVideo text={<I18n k="match.banner.watch_video"/>}
                    video={VIDEO_CONFIG}
                    onOpen={() => reportVideoWatch(bqContext)}
                    sourceInfo={sourceInfo}/>
            </div>
        </div>
    );
};

const WebsiteMatchTitle = () => {
    let titleSubset;

    return (<div className="title-wrapper">
        <I18n k="match.banner.title" templates={[
            (text) => <h2 className="main-title">{text}</h2>,
            (text) => <h2 className="dynamic-title">{text}</h2>,
            (text) => {
                titleSubset = text;
                return null;
            },
            (text) => (
                <div className="sub-title-wrapper">
                    <h2 className="sub-title">{titleSubset}</h2>
                    <i className="italic-yellow font-domaine">{text}</i>
                </div>
            )
        ]}/>
    </div>);
};

const WebsiteMatchStep = ({ subtitle, number }) => (
    <div className="step" key={subtitle}>
        <div className="row-ellipse tbody-6">{number}</div>
        <div className="row-text tbody-4">{subtitle}</div>
    </div>
);

WebsiteMatchStep.propTypes = {
    subtitle: string,
    number: string
};

WebsiteMatchBanner.propTypes = {
    context: object
};

export default WebsiteMatchBanner;
